import { UserRoleName } from '@tripointe/tripointe-cms/types';

export const ALLOWED_CONTACTS_ROLES = [
  UserRoleName.divisionAdministrator,
  UserRoleName.builderAdministrator,
  UserRoleName.platformAdministrator
];
